import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';

export default class LoginComponent extends Component {

  get COMPONENTNAME() {
      return 'LoginComponent';
  }

  get SELECTORS() {
    return {
      submitBtn: "[data-js-btn='submit']"
    };
  }

  constructor(elem) {
    super(elem);
    this.trackingComponent = new TrackingComponent();
  }

  readDOM() {
    return {
      submitBtn: this.$component.querySelector(this.SELECTORS.submitBtn),
    }
  }

  bindEvents() {
    this.dom.submitBtn.addEventListener('click', () => {
      let loginType = this.dom.submitBtn.dataset.loginType;
      let params = { loginType : loginType };
      this.trackingComponent.actions.login(params);
    });
  }

  render() {
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
